import { render } from "./add-doctor.vue?vue&type=template&id=c1f1c098"
import script from "./add-doctor.vue?vue&type=script&lang=js"
export * from "./add-doctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__